import { Component, Input } from '@angular/core';
import { HistoryDocument } from '../models/history-document';

@Component({
    selector: 'app-mario-header',
    templateUrl: './mario-header.component.html',
    styleUrls: ['./mario-header.component.css'],
    standalone: false
})
export class MarioHeaderComponent {
  @Input() title!: string;
  @Input() document!: HistoryDocument | undefined;
  @Input() inRcJit = false;
}